/**
 * Settings of the CRM contact views, kept per task type:
 *
 *      {[taskTypeId]: settings}
 *
 * The settings are shared by every contact - the same task type's view looks the same on
 * all of them. The settings themselves are stored as they come - the value is whatever the
 * view's settings store writes (see CrmContact_TasksListSettingsStore).
 */
export default class CrmContactSettings {

    protected _config : Record<ID, any>

    constructor(config: any) {
        this._config = _.isPlainObject(config) ? _.cloneDeep(config) : {}
    }

    get(taskTypeId: ID) {
        return _.get(this._config, [taskTypeId], {})
    }

    // plain assignment, not _.set(): lodash turns a numeric-looking key into an array index
    set(taskTypeId: ID, settings: any) {
        this._config[taskTypeId] = settings
    }

    remove(taskTypeId: ID) {
        delete this._config[taskTypeId]
    }

    toJson() {
        return this._config
    }
}
